import { WfnDatePicker } from '@adp-wfn/mdf-wc-react';
import React from 'react';
import { Field } from './types';

/**
 * Date picker field component with min/max date validation
 * @param props - Field component props
 * @param props.data - Field configuration with value, min, and max dates
 * @param props.onChange - Callback function for date changes
 * @returns JSX element for date picker field
 */
export function Date({ data, onChange }: Field) {
  return (
    <WfnDatePicker
      dateFormat="short"
      label={data.label}
      max={data.max}
      min={data.min}
      required={data.required}
      tooltipText={data.tooltipText}
      value={String(data.value || '')}
      onSdfChange={(event) => onChange(event?.detail)}
    />
  );
}
